import { helpers } from 'vuelidate/lib/validators'

export default maxFileSize =>
  helpers.withParams(
    { type: 'maxFileSize', maxFileSize: maxFileSize },
    function(value, parentVm) {
        if (!value) {
            return true
        } else {
            var maxSize = process.env.VUE_APP_MAX_FILE_BYTES
            return value.size <= maxSize
        }
    }
  )